const serverEnvironment = () => {
  const server = process.env.REACT_APP_SERVER_ENV || "uk";
  const isAuServer = server === "aus" && true;

  return {
    isAuServer,
  };
};

export default serverEnvironment;
